import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-add-account',
    templateUrl: './order-add-account.component.html',
    styleUrls: ['./order-add-account.component.scss'],
    standalone: false
})
export class OrderAddAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
